import React from "react"

import { RoomMultiSelectSidebar } from "./RoomMultiSelectSidebar"
import {
  UseRoomMultiSelectSidebarModelArgs,
  useRoomMultiSelectSidebarModel
} from "./hooks/useRoomMultiSelectSidebarModel"

export const RoomMultiSelectSidebarConnector = React.memo(
  (props: UseRoomMultiSelectSidebarModelArgs) => (
    <RoomMultiSelectSidebar {...useRoomMultiSelectSidebarModel(props)} />
  )
)
